import { render, staticRenderFns } from "./assitant.vue?vue&type=template&id=8c0fbb6a"
import script from "./assitant.vue?vue&type=script&lang=js"
export * from "./assitant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports